import { useState } from 'react';
import { Button, useNotify, useRecordContext } from 'react-admin';
import { downloadReceipt } from '../../utils';

const DownloadButtonReceipt = ({ route, cyclesList, ...rest }) => {
    const notify = useNotify();
    const [disabled, setDisabled] = useState(false);
    const { id, receipt } = useRecordContext();

    const handleDownload = async () => {
        setDisabled(true);
        notify(`Download em andamento, por favor aguarde…`, { type: 'success' });
        await downloadReceipt(`${route}/${id}`, receipt ? `${id}.jpeg` : `${id}.zip`);
        setDisabled(false);
    }

    return receipt || cyclesList ? <Button label="Download" onClick={handleDownload} disabled={disabled} {...rest} /> : 'Indisponível';
}

export default DownloadButtonReceipt;
